<template>
    <div>
        <button v-if="this.serverData.isEditing" type="button" @click="gotoConfigurations"> {{translationHelper.getTranslation("camp_socialmedia_button_edit")}}</button>
        <posts v-if="configurationsLoaded && (configurations.selectedBroadcastFilters.layout == null || configurations.selectedBroadcastFilters.layout ==='Posts')"></posts>
        <button v-if="this.serverData.isEditing" type="button" @click="gotoConfigurations"> {{translationHelper.getTranslation("camp_socialmedia_button_edit")}}</button>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import SocialMedia from "../../../../_Api/SocialMedia";
import Posts from "./Posts.vue";
export default {
    components: {
        Posts
    },
    data() {
        return {
            content: 'Output Component',
        }
    },
    mounted() {
        if ( this.configurationsLoaded ) {
            this.startComponent();
        }
    },
    watch: {
        configurations( newvalue, oldValue ) {
            //In case the configuration was not loaded on the mounted event yet
            if ( newvalue && oldValue == null ) {
                this.startComponent();
            }
        }
    },
    computed: {
        ...mapGetters( [ "serverData", "translationHelper", "configurations", "configurationsLoaded" ] )
    },
    methods: {
        startComponent() {},
        gotoConfigurations() {
            this.$router.push( { name: "Configurations" } );
        }
    }

}
</script>
